
import Vue from "vue";
import AppPriceItem from "./PriceItem.vue";
import AppItemOption from "./PriceItemOption.vue";
import { Plan } from "../../utils/payments/plan";
import { PriceFrequencyType, Pricing } from "../../models/payment/pricing";

export default Vue.extend({
	props: {
		selectedFrequencyType: {
			type: Number as ()=>PriceFrequencyType
		},
		currentPlan: {
			type: Object as ()=>Plan
		},
		pricing: {
			type: Object as ()=>Pricing
		},
		vertical: Boolean,
		hasNoPlan: Boolean
	},
	computed: {
		lgSize():number{
			if (this.vertical){
				return 12;
			}
			return 4;
		}
	},
	components: {
		AppPriceItem,
		AppItemOption
	},
	i18nEx: {
		componentPrefix: "components.account"
	}
});
